// extracted by mini-css-extract-plugin
export var searchContainer = "index-module--searchContainer--abBc_";
export var searchInput = "index-module--searchInput--2UFMx";
export var lightSearchInput = "index-module--lightSearchInput--2M_Md";
export var search = "index-module--search--23Gqu";
export var bookingButton = "index-module--bookingButton--3rA0g";
export var bookingLight = "index-module--bookingLight--2R5sX";
export var bookingDark = "index-module--bookingDark--DMz-x";